import { computed, reactive } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useSnackbar } from 'vue3-snackbar';

export default function useConsultaForm(service) {
    const store = useStore();
    const snackbar = useSnackbar();

    const state = reactive({
        id: '',
        name: '',
        indicaciones: '',
        status: 1,
    });

    const setState = (c) => {
        state.id = c.id;
        state.name = c.name;
        state.indicaciones = c.indicaciones;
        state.status = c.status;
    };

    /** ***** Validator ***** */
    const rules = computed(() => ({
        name: { required },
        indicaciones: { required },
    }));

    const v = useVuelidate(rules, state);

    const resetForm = () => {
        v.value.$reset();
        state.id = '';
        state.name = '';
        state.indicaciones = '';
        state.status = 1;
    };

    const handleAction = async (action) => {
        if (await v.value.$validate()) {
            let text;
            switch (action) {
                case 'create':
                case 'create_view':
                    await service.createMedicamento(state);
                    if (action === 'create_view') {
                        store.dispatch('ContentManager/openWindow', {
                            id: `MedicamentoForm_${service.medicamento.value.id}`,
                            component: 'MedicamentoForm_',
                            name: service.medicamento.value.name,
                            params: {
                                title: 'Consulta',
                                headerTitle: `Ver ${service.medicamento.value.name}`,
                                item: { ...service.consulta.value },
                            },
                        });
                    }
                    text = 'Medicamento credo con exito';
                    resetForm();
                    break;
                case 'save':
                    await service.updateMedicamento(state.id, state);
                    text = 'Medicamento actualizado con exito';
                    break;
                default:
                    break;
            }
            snackbar.add({
                type: 'success',
                text,
            });
        } else {
            console.log(v.$errors);
            snackbar.add({
                type: 'error',
                text: 'Ups no podemos enviar la informacion sin algunos datos',
            });
        }
    };

    return {
        v,
        state,
        setState,
        resetForm,
        handleAction,
    };
}
